import { Deserializable } from '../protocols/deserializable';

export class RemittanceSource implements Deserializable {
  public id!: number;
  public name!: string;

  public onDeserialize() {}
}
